<template>
    <div v-if="useDesktopAspectRatio" :class="ui.wrapper" :style="ui.wrapperStyle">
        <div :class="ui.inner">
            <CloudImg
                :image-id="config.image.imageId"
                :alt="config.image.alt"
                :aspect-ratio="config.image.aspectRatio"
                :class="config.ui"
            />
        </div>
    </div>
    <CloudImg
        v-else
        :image-id="config.image.imageId"
        :alt="config.image.alt"
        :aspect-ratio="config.image.aspectRatio"
        :class="config.ui"
    />
</template>

<script setup lang="ts">
import CloudImg from './CloudImg.vue'
import { useIsDesktop } from '~~/layers/base/composables/useIsDesktop'
import type { ImageBlockConfig } from '~~/layers/base/types/blockConfigs'

const props = defineProps<{
    config: ImageBlockConfig
}>()

const { isDesktop } = useIsDesktop()

const useDesktopAspectRatio = computed(() =>
    Boolean(props.config.desktopAspectRatio && isDesktop.value)
)

/** When desktopAspectRatio is set and desktop: fixed ratio box, image cropped and centered. */
const ui = computed(() => {
    const ratio = props.config.desktopAspectRatio
    if (!ratio) return { wrapper: '', wrapperStyle: {}, inner: '' }
    return {
        wrapper: 'relative w-full overflow-hidden',
        wrapperStyle: { aspectRatio: ratio },
        inner: 'absolute inset-0 [&>div]:!h-full [&>div]:!w-full [&>div]:!min-h-0 [&>div]:!aspect-auto [&_img]:object-cover [&_img]:object-center [&_img]:w-full [&_img]:h-full [&_img]:min-h-0',
    }
})
</script>
